export const exterior_view05ImageOptions = {
  angle: 'exterior_view05',
  staticOptions: {
    HullColour: 1,
    Bowsprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHoodType: 1,
    SprayHood: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'SprayHoodType',
      dependency: null
    },
    {
      option: 'SprayHood',
      dependency: 'SprayHoodType'
    },
    {
      option: 'Wheel',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC38/views/exterior_view05.js